export const ROUTE_CONSTANT = {
  MUSIC_EDITOR: "/app/music-editor",
  MUSIC_EDITOR_LOCALE: "/app/:locale/music-editor",
  SONG_SUMMARY: "/app/music-editor/song-summary",
  SONG_SUMMARY_LOCALE: "/app/:locale/music-editor/song-summary",
  /** Legacy paths kept for redirects */
  SONG_SUMMARY_LEGACY: "/app/song-summary",
  SONG_SUMMARY_LEGACY_LOCALE: "/app/:locale/song-summary",
  SONG_SUMMARY_ALT: "/song-summary",
  DASHBOARD_TRANSFER: "/app/dashboard",
  DASHBOARD_TRANSFER_LOCALE: "/app/:locale/dashboard",
  SONG_DETAILS: "/app/song-details",
  SONG_DETAILS_LOCALE: "/app/:locale/song-details",
  MUSIC_PLAYER: "/app/music-editor/player",
  MUSIC_PLAYER_LOCALE: "/app/:locale/music-editor/player",
  TRACK_SONG: "/app/music-editor/track-song",
  TRACK_SONG_LOCALE: "/app/:locale/music-editor/track-song",
  /** Deprecated order-summary URLs — redirect to track-song */
  ORDER_SUMMARY_LEGACY: "/app/music-editor/order-summary",
  ORDER_SUMMARY_LEGACY_LOCALE: "/app/:locale/music-editor/order-summary",
  ORDER_SUMMARY_LEGACY_ALT: "/app/order-summary",
  ORDER_SUMMARY_LEGACY_ALT_LOCALE: "/app/:locale/order-summary",
  TRACK_SONG_LEGACY: "/app/track-song",
  TRACK_SONG_LEGACY_LOCALE: "/app/:locale/track-song",
} as const;
